module.exports = __webpack_public_path__ + "img/2-2.26e72a32.png";